module.exports = {
  AGB: { api: 'AGB', human: 'Garantiebedingung' },
  GKV: { api: 'GKV', human: 'Garantiekostenversicherung' }
}
